<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">{{options.title}}</v-card-title>
        <v-card-text>{{options.message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-show="options.showCancel" color="green darken-1" text @click="confirm(0)">Cancel</v-btn>
          <v-btn v-show="options.showOk" color="green darken-1" text @click="confirm(1)">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'VAlert',
    props:["options"],
    data() {
        return {
          dialog: false
        }
    },
    methods: {
        open() {
          this.dialog = true;
        },
        close() {
          this.dialog = false;
        },
        confirm(result) {
            this.dialog = false
            this.$emit('callback', result)
        }
    }
}
</script>
